import React from "react"

import { ZoomLens } from "../ZoomLens"

import "./layout-accordion.css"

const LayoutAccordion = ({ data }) => {
    return (
        <div className="variant-accordion">
            {data.gallery.map((item, index) => (
                <ZoomLens key={index} imgUrl={item.gatsbyImageData.images.fallback.src} />
            ))}
        </div>
    )
}

export default LayoutAccordion